import { IButtonLinkProps, IButtonProps } from "./button.models";
import { buttonClass } from "./button.utils";

export const Button = ({
  variant = "primary",
  size = "md",
  className,
  type = "button",
  ...props
}: IButtonProps) => (
  <button
    type={type}
    className={buttonClass({ variant, size, className })}
    {...props}
  />
);

/**
 * Plain `<a>` on purpose: the landing is a set of static HTML pages, so links
 * must be crawlable and work with JS disabled.
 */
export const ButtonLink = ({
  variant = "primary",
  size = "md",
  className,
  ...props
}: IButtonLinkProps) => (
  <a className={buttonClass({ variant, size, className })} {...props} />
);
